import { createActionGroup, props } from "@ngrx/store";
import { CopiedEntityData } from "src/app/shared/interfaces/interfaces";

export const ClipboardActions = createActionGroup({
    source: "Clipboard",
    events: {
        "Update": props<{ data: CopiedEntityData | null }>(),
    },
});
